import React, { useEffect, useMemo, useParams, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { Box, CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";

import TableMaestros from "verticales/TableMaestros.tsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 54,
  pl: 2,
  pr: 2,
  pt: 0,
  pb: 2,
};

const CircularProgressWithLabel = ({ value }) => {
  const getColor = (value) => {
    if (value < 5) return "error.main"; // Rojo
    if (value > 5 && value <= 100) return "success.main"; // Verde
    return "error.main"; // Valor por defecto en caso de que sea menor a 30 90%
  };

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" value={value} sx={{ color: getColor(value) }} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="textPrimary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

function TableDiscosEc2(props: any) {
  // console.log("Discos...", props);

  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      { header: "Disco", accessorKey: "disk" },
      { header: "Tamaño", accessorKey: "total_size" },
      { header: "Espacio en Uso", accessorKey: "used_space" },
      {
        header: "% Libre",
        accessorKey: "free_percent",
        Cell: ({ cell }) => <CircularProgressWithLabel value={cell.getValue()} />,
      },
    ],
    []
  );

  return (
    <Grid item xs={12} md={12} lg={12}>
      <MDBox m={1}>
        <TableMaestros arrayColumns={columns} data={props.data} height={250} noActionsEdit={true} />
      </MDBox>
    </Grid>
  );
}
CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

TableDiscosEc2.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      disk: PropTypes.string.isRequired,
      total_size: PropTypes.number.isRequired,
      used_space: PropTypes.number.isRequired,
      free_percent: PropTypes.number.isRequired,
    })
  ).isRequired,
  cell: PropTypes.shape({
    getValue: PropTypes.func.isRequired, // Validate 'getValue' as a required function
  }),
};

export default TableDiscosEc2;
